import { Box as MuiBox, styled as muiStyled } from "@mui/material";

export const Box = muiStyled(MuiBox)`
  &.container {
    width: 100%;
    height: 100%;
  }
  
  &.content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  &.title {
    font-size: 2.5vw;
    font-weight: bold;
    margin-bottom: 40px;
  }
  
  &.buttons-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  &.button-row {
    display: grid;
    grid-gap: 2%;
    grid-template-columns: repeat(3, 32%);
  }
`;
